import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';

const ERROR_MESSAGES = {
	INIT_FAILED: 'Tooltips: Initialization failed'
};

const CONFIG = {
	TOOLTIP_OPTIONS: {
		trigger: 'hover',
		html: true,
		template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
		offset: [0, 15]
	}
};

/**
 * Initialize Bootstrap tooltips
 * @returns {void}
 */
const initializeTooltips = () => {
	try {
		const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
		
		tooltipTriggerList.forEach(tooltipTriggerEl => {
			new bootstrap.Tooltip(tooltipTriggerEl, CONFIG.TOOLTIP_OPTIONS);
		});
	} catch (error) {
		console.error(ERROR_MESSAGES.INIT_FAILED, error);
	}
};

export { initializeTooltips };
